webpackJsonp([11618256343130],{

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Components
	
	
	var PageWrapper = _styledComponents2.default.section(_templateObject);
	
	var StandaloneCardPage = function StandaloneCardPage() {
	
	  return _react2.default.createElement(
	    PageWrapper,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'The Card Component'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This component is baked out into static HTML. It was a stateless functional React component, which is just a pure render function, and we know the props at build time.'
	    ),
	    _react2.default.createElement(_Card2.default, {
	      title: 'Vitamin C',
	      description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
	      friendlytitle: 'Boosts your immune system',
	      colors: ['rgba(0, 0, 0, 0.05)'] })
	  );
	};
	
	exports.default = StandaloneCardPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-jamstack-card-js-337ebff43d0bb73f04ff.js